import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class PslfEmployerController extends Controller {
  @tracked approval = '';

  queryParams = ['approval'];
}
